import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=a65b170c&scoped=true&"
import script from "./Pdf.vue?vue&type=script&lang=js&"
export * from "./Pdf.vue?vue&type=script&lang=js&"
import style0 from "./Pdf.vue?vue&type=style&index=0&id=a65b170c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65b170c",
  null
  
)

export default component.exports